import { render, staticRenderFns } from "./DermaSpecialistMain.vue?vue&type=template&id=77617cb8&"
import script from "./DermaSpecialistMain.vue?vue&type=script&lang=js&"
export * from "./DermaSpecialistMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports